
class Point {
    constructor(x = 0,y = 0) {
        this.x = x;
        this.y = y;
    }
}

export default Point;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/structures/Point.js